import type { ComponentProps } from "react"

// Speech bubble with sparkles; the chat landing hero. Strokes and fills
// follow currentColor so the icon recolours with the text.
export default function AiChat(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
      {...svgProps}
    >
      <path
        d="M2.66601 2H13.3327C13.5979 2 13.8522 2.10536 14.0398 2.29289C14.2273 2.48043 14.3326 2.73478 14.3326 3V11C14.3326 11.2652 14.2273 11.5195 14.0398 11.7071C13.8522 11.8946 13.5979 12 13.3327 12H6.99934L3.99934 14.6666V12H2.66601C2.4008 12 2.14644 11.8946 1.95891 11.7071C1.77137 11.5195 1.66602 11.2652 1.66602 11V3C1.66602 2.73478 1.77137 2.48043 1.95891 2.29289C2.14644 2.10536 2.4008 2 2.66601 2Z"
        stroke={fill}
        strokeWidth="0.833331"
      />
      <path
        d="M7.66601 4L8.33267 6.33333L10.666 6.99999L8.33267 7.66666L7.66601 9.99999L6.99934 7.66666L4.66602 6.99999L6.99934 6.33333L7.66601 4Z"
        fill={fill}
      />
      <path
        d="M11.3333 3.16699L11.6333 4.20032L12.6667 4.50032L11.6333 4.80032L11.3333 5.83365L11.0333 4.80032L10 4.50032L11.0333 4.20032L11.3333 3.16699Z"
        fill={fill}
      />
      <path
        d="M11.3333 8.16699L11.5333 8.80032L12.1667 9.00032L11.5333 9.20032L11.3333 9.83365L11.1333 9.20032L10.5 9.00032L11.1333 8.80032L11.3333 8.16699Z"
        fill={fill}
      />
    </svg>
  )
}
